import { MultiselectFilter, FilterRowTextLabel } from '../generic';
import { Filter, FilterOption } from '@model/iceberg';
import { TestId } from '@components/test-ids';
import React from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';

/* ********** *
 *    Types   *
 * ********** */
export interface MultiselectFilterProps {
  filter: Filter;
  onChange: (payload: Filter) => void;
  visibleNumberOfFilters?: number;
  showCount?: boolean;
  testId?: string;
}

/* *********** *
 *    Styles   *
 * *********** */

const Count = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  marginLeft: theme.custom.spacing.xSmall
}));

export const CheckboxFilter = (props: MultiselectFilterProps) => {
  const { showCount = true } = props;
  const renderLabel: (filterOption: FilterOption) => JSX.Element = ({ name, count, selected }: FilterOption) => (
    <FilterRowTextLabel
      data-testid={TestId.multiselectFilters.textFilterLabel}
      isSelected={selected}
      available={!!count}
    >
      {name} {!!count && showCount && <Count>({count})</Count>}
    </FilterRowTextLabel>
  );

  return <MultiselectFilter {...props} renderLabel={renderLabel} />;
};
